import config from './_config';
import getContext from './_getContext';
import useGetLangPath from './getLangPath';

export { config, getContext, useGetLangPath };
